import { Layout, Spin, Statistic } from 'antd'
import React, { useContext, useEffect, useState } from 'react'
import BoxContext from './BoxContext'
import { get } from '../../Common/api'
import CustTable from '../../Common/CustTable'
import { t } from 'i18next'
import FullCalendar from '@fullcalendar/react'
import multiMonthPlugin from '@fullcalendar/multimonth'
import frLocale from '@fullcalendar/core/locales/fr'
const { Countdown } = Statistic

const FormatAvailabilities = ({ availabilities }) => {
  const events = []
  Object.keys(availabilities).forEach((day) => (availabilities[day].forEach((slot) => events.push({ title: 'Dispo', start: slot.time }))))

  return (
    <>
      <FullCalendar
        height="auto"
        selectable={true}
        plugins={[multiMonthPlugin]}
        initialView='multiMonthFourMonth'
        locale={frLocale}
        events={events}
        views={{ multiMonthFourMonth: { type: 'multiMonth', duration: { months: 3 } } }}
      />
      <p>&nbsp;</p>
      <p>&nbsp;</p>
    </>
  )
}
const columns = () => [
  {
    title: t('Admin.SpecialistList.table.name'),
    dataIndex: 'name',
    key: 'name',
    width: 50,
    render: (name) => (t(`Admin.SpecialistList.name.${name.slice(0, 2)}`))
  },
  {
    title: t('Admin.SpecialistList.table.availabilities'),
    dataIndex: 'availabilities',
    key: 'availabilities',
    width: 200,
    render: (availabilities) => (
      availabilities ? <FormatAvailabilities availabilities={availabilities} /> : 'Aucune')
  }
]

export default function BoxSpecialistsPage () {
  const [specialists, setSpecialists] = useState()
  const [status, setStatus] = useState('in_progress')
  const [loading, setLoading] = useState(false)
  const [countdown, setCountdown] = useState(0)
  const { box } = useContext(BoxContext)
  const DELAY = 10

  useEffect(() => {
    if (box) {
      getSpecialists()
    }
  }, [box])

  const getSpecialists = async () => {
    setLoading(true)
    const url = `admin/boxes/${box.id}/specialists`
    if (location.pathname !== '/' + url) { return }
    await get({
      url,
      params: {},
      onSuccess: (json) => {
        if (json === 'in_progress') {
          setCountdown(Date.now() + DELAY * 1000)
          setStatus('in_progress')
          setTimeout(() => {
            getSpecialists(true)
          }, DELAY * 1000)
        } else {
          setStatus('loaded')
          setSpecialists(json.sort((a, b) => a.name.localeCompare(b.name)))
          setLoading(false)
        }
      },
      onFailure: () => {
        setStatus('error')
        setLoading(false)
      }
    })
  }

  return (
    <Layout style={{ padding: '1em', backgroundColor: 'white' }} class="specialistAvailabilities">
      <Spin spinning={loading}>
        {status !== 'loaded' && t(`Admin.SpecialistList.status.${status}`)}
        {status === 'in_progress' && <Countdown type="countdown" title="Rechargement dans "value={countdown} format="ss" /> }
        {status === 'loaded' &&
          <CustTable
            style={{ height: 'calc(100vh - 350px)' }}
            height={700}
            initColumns={columns()}
            dataSource={specialists}
            key={'id'}
          />
        }
      </Spin>
    </Layout>
  )
}
